import {useRef, useState} from 'react';
import { Redirect } from 'react-router-dom'
import { useReactToPrint } from 'react-to-print';
import { useLocalisationService } from 'providers/LocalisationProvider';
import { ReportTypes } from 'fixit-shared/FirestoreKeys';
import { CertificateOfAchievement } from './CertificateOfAchievement';
import { CERTIFICATE_PAGE_STYLE } from 'helpers/print';

export const CertificateOfAchievementSummary = props => {
    const {location, telemetryService} = props;
    const l = useLocalisationService();
    const [editNotes, setEditNotes] = useState(true);
    const [hasFinished, setHasFinished] = useState(false);
    const certificate = location.certificate;
    const printComponentRef = useRef();

    const renderSave = () => {
      return (
      <div className='flexbox'>          
        <button className='primary-button summary-button summary-text rounded flexbox' onClick={onSave}>
          {l.getString('save')}
        </button>
      </div>
      )
    }
  
    const onSave = () => {
  
      certificate.save(ReportTypes.CertificateOfAchievement)
      .then(success => setHasFinished(success));
  
      const telemetryProps = {
        profile_uuid: certificate.profile().id,
        certificate_id: certificate.id(),
        summary: certificate.toJson().questions,
        duration: Date.now() - certificate.date,
        // schoool_id,
        // class_level,
      };
      telemetryService.reportEvent('certificate_of_achievement.completed', telemetryProps);
    }

    const _handlePrint = useReactToPrint({
      onBeforeGetContent: () => {setEditNotes(false); return Promise.resolve();},
      onAfterPrint: () => {setEditNotes(true); return Promise.resolve();},
      content: () => printComponentRef.current,
      pageStyle: CERTIFICATE_PAGE_STYLE,
    });

    const printString = l.getString('print');

    if(!certificate){
      return <Redirect to="profiles"/>
    }

    if(hasFinished){
      return <Redirect to='/profiles' />;
    }

    return (
<div className = 'certificate-of-achievement'> 
    <div className='noselect'>    
        <CertificateOfAchievement
          ref={printComponentRef}
          certificate = {certificate}
          editNotes = {editNotes}
        />
        <div className='summary-options centered flexbox'> 
          {renderSave()}
          <button onClick={_handlePrint} className='secondary-button summary-button summary-text rounded flexbox'>{printString}</button>
        </div>
      </div>
    </div>
    );
  }